<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div class="fullContent">
    <div class="containerContent scrollList">
        <v-row>
          <v-col cols="12" class="pa-0 pr-1" style="height: fit-content;">
            <div v-if="!hasPWAInstall" style="float:left;" class="ml-5 mt-3 mb-3" @click="dialogPWA = true;"> 
              <v-icon dark>save_alt</v-icon>
              <span class="caption ml-1 mt-1">Add Shortcut</span>
            </div>  
            <div style="text-align: right;" class="pt-2 pb-1 mr-3">
              <Menu></Menu>
            </div>
            <Header :provinceDisplay="provinceDisplay" class="ml-3 mb-3 mt-1"></Header>
            <Overview ref="Overview" @filterProvince="filterProvince"/>
          </v-col>
          <v-col cols="12">
            <Stats ref=Stats></Stats>
          </v-col>
          <v-col cols="12" style="height: fit-content;">
            <v-row style="height: fit-content;">
              <v-col cols="12" class="pr-1 pb-1">
                <ProvinceList ref="ProvinceList"/>
              </v-col>
              <v-col cols="12" class="pr-1 pb-1" style="min-height: 500px;">
                <Map ref="Map"/>
              </v-col>
            </v-row>
            <v-row style="height: fit-content;">
              <v-col cols="12" class="pr-1">
                <Graph ref="Graph"/>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
    </div>
    <v-dialog v-model="dialogPWA" fullscreen>
      <v-card>
        <v-card-title class="title purple darken-1 white--text">Add Shortcut Instructions</v-card-title>
        <v-card-text>
          <div class="body-1 mt-3">
            This app can be added as an shortcut on your mobile phone home screen for quick and easy access. To add:
            <br/><br/>
            <span style="font-weight: bold;">▪ On iOS open the link in Safari: </span><br/>Tap the share icon <img src="../../public/assets/share_ios.png" style="height: 20px;" class="ml-2" /><br/> Tap Add to Home Screen.<br/><br/><br/>
            <span style="font-weight: bold;">▪ On Android open the link in Chrome:</span> <br/>Tap the share icon <img src="../../public/assets/share_android.png" style="height: 20px;" class="ml-2" /><br/> Tap Add to Home Screen.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="dialogPWA = false" color="purple">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Map from '@/components/Map.vue'
  import Overview from '@/components/Overview.vue'
  import ProvinceList from '@/components/ProvinceList.vue'
  import Graph from '@/components/Graph.vue'
  import Menu from '@/components/Menu.vue'
  import Header from '@/components/Header.vue'
  import Stats from '@/components/Stats.vue'

  export default {
    name: 'DashboardMobile',
    data: () => ({
      provinceDisplay: "",
      dialogPWA: false,
      summaryData: []
    }),
    components: {
      Map,
      Overview,
      ProvinceList,
      Graph,
      Menu,
      Header,
      Stats
    },
    mounted () {
      //post the GA
      gtag('event', 'page_view', {
        'send_to': 'UA-161523063-1'
      })
    },
    computed: {
      hasPWAInstall: function() {
        return window.matchMedia('(display-mode: standalone)').matches
      }
    },
    methods: {
      loadCases(summaryCases, provinceDisplay) {
        //store data
        this.summaryData = summaryCases

        this.$refs.Overview.loadCases(summaryCases, provinceDisplay)
        this.$refs.ProvinceList.loadCases(summaryCases, provinceDisplay)
        this.$refs.Map.loadCases(summaryCases, provinceDisplay)
        this.$refs.Graph.loadCases(summaryCases, provinceDisplay)
        this.$refs.Stats.loadCases(summaryCases, provinceDisplay)
      },
      loadLastUpdated(data) {
        this.$refs.Overview.loadLastUpdated(data)      
      },
      loadInterventions(data) {
        this.$refs.Graph.loadInterventions(data)       
      },
      loadGlobalStats(confirmedData, continents) {
        this.$refs.Graph.loadGlobalStats(confirmedData, continents)
      },
      filterProvince(prov) {
        if(prov !== "National") {
          this.provinceDisplay = prov
        }
        else {
          this.provinceDisplay = ""
        }        

        this.loadCases(this.summaryData, this.provinceDisplay)
      },
      resize() {
        this.$refs.Map.resize()
      }
    }
  }
</script>

<style scoped>
.fullContent {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .containerContent {
    height: 100%;
    background: linear-gradient(to bottom left,#216e93,#21648a,#1f5881,#172d5b,#191c51);
    color: #fff;
  }
</style>
